import React from 'react';
import Crypto2 from '../../images/crypto-2.svg'
import VideoCover from '../../images/video-cover.png'
import HomePageHeader from '../../images/home-page-header.png'
import AdvancedTargetingImage from '../../images/index/advanced-targeting.png'
import CollectEmailImage from '../../images/index/collect-email.png'
import GamificationImage from '../../images/index/gamification.png'
import PromoteProductsImage from '../../images/index/promote-products.png'
import ShowUpAnnouncement from '../../images/index/show-up-announcement.png'
import Acordion from '../acordion/Acordion';

let faqData = [
    {
        title:'Do I need to have coding or design skills to use Popupfox?',
        description:'No, you don’t need to have coding or design skills to create stunning popups with Popupfox. We have made the popup design process as simple as possible for you. To do so, select what you desire from the design options and add the code that the system generates to your website. As long as you follow our instructions, you can create a conversion-optimized popup in 2 minutes without any special skills.'
    },
    {
        title:'Why should I choose Popupfox?',
        description:'We believe that each website is unique and has different requirements. Because of this, we have provided a wide range of design options and made the process incredibly simple for you. Unlike many of our competitors, we guarantee that you can design engaging popups in as little as 2 minutes. Besides, it’s free!'
    },
    {
        title:'Does Popupfox affect my website’s speed?',
        description:'No, the Popupfox do not affect the speed of your website. All of the popups you design with Popupfox are SEO-friendly. Popupfox does not have a negative impact on any step of Search Engine Optimization practices, including website speed. On the contrary, popupfox support these practices.'
    },
];

class SectionOne extends React.Component {
  render() {
    return (
      <div className="main-container">
        <section className="cover unpad--bottom switchable switchable--switch bg-home-page-header text-center-xs">
          <div className="container">
            <div className="row align-items-center justify-content-around home-page-header-padding">
              <div className="col-md-6 col-lg-6 mt-0 ">
                <h1 className="h1-Bold-font">
                  Convert your visitors into customers with popups.
                </h1>
                <p className="lead pading-header-p">
                  Popupfox delivers top-tier popups at the world's best prices. High-quality doesn't mean high-cost. With Popupfox, you get unmatched speed and value.
                </p>
                <div className="row align-items-center justify-content-around">
                  <div className="col-md-6">
                    <div className="row align-top-icon-zero">
                      <div className="col-lg-2 col-md-3 ">
                        <i className="icon icon-Yes color--primary"></i>
                      </div>
                      <div className="col-lg-10 col-md-9 margin-auto-div ">
                        <p>Best Price & Best Speed</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row align-top-icon-zero">
                      <div className="col-lg-2 col-md-3 ">
                        <i className="icon icon-Yes color--primary"></i>
                      </div>
                      <div className="col-lg-10 col-md-9 margin-auto-div ">
                        <p>Easy Setup </p>
                      </div>
                    </div>
                  </div>
                </div>
                <a
                  id="landing--try-now--section1-link"
                  className="btn btn--primary type--uppercase btn-home-page-header-padding"
                  href="https://dashboard.popupfox.com/register"
                >
                  <span className="btn__text btn__marging_home_page">
                  LAUNCH THE BUILDER
                  </span>
                </a>
              </div>
              <div className="col-md-6">
                <img alt="image" src={HomePageHeader} />
              </div>
            </div>
          </div>
        </section>

        <hr />

        <section className="text-center">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-8">
                <h2>Advanced Features</h2>
                <p className="lead">
                  The advanced features of Popupfox popups add value to your
                  website and improve the growth of your business significantly.
                  We offer you more and better.
                </p>
              </div>
            </div>
          </div>
        </section>


        <section class="switchable feature-large">
                <div class="container">
                    <div class="row">
                        <div class="col-md-6">
                            <img alt="Image" src={ShowUpAnnouncement} />
                        </div>
                        <div class="col-md-6 col-lg-5">
                            <div class="switchable__text">
                                <h2>No skills needed with a simple no-code interface</h2>
                                <p class="lead">
                                No need for coding or design skills to have a custom popup. Simply create your design and integrate your popup to your website easily. It only takes 2 minutes.
                                </p>
                                <a href="https://dashboard.popupfox.com/register">Try for free »</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="switchable feature-large">
                <div class="container">
                    <div class="row">
                        <div class="col-md-6">
                            <img alt="Image" src={CollectEmailImage} />
                        </div>
                        <div class="col-md-6 col-lg-5">
                            <div class="switchable__text">
                                <h2>Pop a popup and get excellent conversion rates</h2>
                                <p class="lead">
                                Be sure that your visitors take the action you desire. It’s easy to convert your website traffic into leads and sales. Increase conversion rates and boost your sales with optimized popups.
                                </p>
                                <a href="https://dashboard.popupfox.com/register">Try for free »</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>



            <section class="switchable feature-large">
                <div class="container">
                    <div class="row">
                        <div class="col-md-6">
                            <img alt="Image" src={AdvancedTargetingImage} />
                        </div>
                        <div class="col-md-6 col-lg-5">
                            <div class="switchable__text">
                                <h2>Decrease cart abandonment with exit-intent popups</h2>
                                <p class="lead">
                                  Keep your visitors when they are about to leave your website. Decrease cart abandonment, increase sales, interact with your visitors, and get the information you need with exit-intent popups.
                                </p>
                                <a href="https://dashboard.popupfox.com/register">Try for free »</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        <section className="text-center bg--secondary">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-8">
                <h2>What you get with Popupfox</h2>
                <p className="lead">
                  Customize fully responsive, targeted, and optimized popups!
                  Create unique marketing campaigns in minutes. Here is why you
                  should opt for Popupfox!
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="bg--secondary">
          <div className="container">
            <div className="row">
              <div className="col-md-4">
                <div className="feature feature-2 boxed boxed--border">
                  <i className="icon icon-Clock-Back color--primary"></i>
                  <div className="feature__body">
                    <p>
                      Popupfox is SEO-friendly. They do not affect the speed of
                      your website.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="feature feature-2 boxed boxed--border">
                  <i className="icon icon-Duplicate-Window color--primary"></i>
                  <div className="feature__body">
                    <p>
                      We offer you over 70 key-ready templates. You don't need
                      any coding or design skills.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="feature feature-2 boxed boxed--border">
                  <i className="icon icon-Life-Jacket color--primary"></i>
                  <div className="feature__body">
                    <p>
                      If you're not satisfied, we guarantee a full refund within
                      30 days of purchase.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="feature feature-2 boxed boxed--border">
                  <i className="icon icon-Pen color--primary"></i>
                  <div className="feature__body">
                    <p>
                      We provide 24/7 email and live chat support. You don't
                      have to worry about surprise errors.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="feature feature-2 boxed boxed--border">
                  <i className="icon icon-Pantone color--primary"></i>
                  <div className="feature__body">
                    <p>
                      Conversion ready popups. You can convert visitors into
                      customers in 2 minutes.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="feature feature-2 boxed boxed--border">
                  <i className="icon icon-Fingerprint color--primary"></i>
                  <div className="feature__body">
                    <p>Integration with more than 50 services.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="switchable ">
          <div className="container">
            <div className="row justify-content-between">
              <div className="col-md-6 col-lg-5">
                <Acordion data={faqData} />
              </div>
              <div className="col-lg-6 col-md-6">
                <img src={Crypto2} alt="Image" />
              </div>
            </div>
          </div>
        </section>

        <section className=" bg--secondary">
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-lg-4">
                <div className="testimonial testimonial-2">
                  <div className="testimonial__body boxed boxed--border bg--secondary">
                    <p>
                      It may be the simplest interface I've ever used. I can't
                      believe I can do this. Seriously! I don't know anything
                      about coding and I thought I couldn't handle this, but
                      it's so simple... I feel like a pro developer. Try it and
                      you'll see what I mean.
                    </p>
                  </div>
                  <div className="testimonial__image">
                    <h5>Mia S.</h5>
                    <span>Oregon, US</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div className="testimonial testimonial-2">
                  <div className="testimonial__body boxed boxed--border bg--secondary">
                    <p>
                      Indeed, it took me less than 10 minutes to design and
                      activate a pop-up on my website as promised. I didn't pay
                      any money or give out my credit card info. Just added the
                      code they gave me before the &lt;/body&gt; tag and voila!
                      Everything looks perfect. Thank you for making things so
                      easy.
                    </p>
                  </div>
                  <div className="testimonial__image">
                    <h5>Hasan V.</h5>
                    <span>London, EN</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div className="testimonial testimonial-2">
                  <div className="testimonial__body boxed boxed--border bg--secondary">
                    <p>
                      I wasn't sure about using it because there aren’t many
                      comments yet, but I decided to give it a shot. I've added
                      a number of pop-ups to some pages of my website, including
                      exit-intent. So far, they're working smoothly. If it won’t
                      cause problems in the long run, I may go premium. Feel
                      free to try.
                    </p>
                  </div>
                  <div className="testimonial__image">
                    <h5>Josephine L.</h5>
                    <span>California, US</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          className="text-center imagebg"
          data-gradient-bg="#4876BD,#5448BD,#8F48BD,#BD48B1"
        >
          <canvas id="granim-0" width="1920" height="469"></canvas>
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-lg-6">
                <div className="cta">
                  <h2>Start designing your free popup now!</h2>
                  <p className="lead">
                    Designing popups with Popupfox is a breeze! Create
                    engagement guaranteed popups to boost your sales right now!
                  </p>
                  <a
                    id="home--try-for-free--layout-link"
                    className="btn btn--primary type--uppercase"
                    href="https://dashboard.popupfox.com/register"
                  >
                    <span className="btn__text">Try for free</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="switchable ">
          <div className="container">
            <div className="row justify-content-between">
              <div className="col-md-6 text-center">
                <div className="video-cover border--round box-shadow-wide">
                  
                <iframe
                    width="560"
                    height="315"
                    src="https://www.youtube.com/embed/nZcAuJczq-c"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>

                
                </div>
              </div>
              <div className="col-md-6 col-lg-5">
                <ol className="process-3">
                  <li className="process_item process_item_margin_bottom">
                    <div className="process__number">
                      <span>1</span>
                    </div>
                    <div className="process__body margintop_process__body">
                      <h4>Sign up</h4>
                    </div>
                  </li>
                  <li className="process_item process_item_margin_bottom">
                    <div className="process__number">
                      <span>2</span>
                    </div>
                    <div className="process__body margintop_process__body">
                      <h4>Choose your template</h4>
                    </div>
                  </li>
                  <li className="process_item process_item_margin_bottom">
                    <div className="process__number">
                      <span>3</span>
                    </div>
                    <div className="process__body margintop_process__body">
                      <h4>Verify your domain</h4>
                    </div>
                  </li>
                  <li className="process_item process_item_margin_bottom">
                    <div className="process__number">
                      <span>4</span>
                    </div>
                    <div className="process__body margintop_process__body">
                      <h4>Design your popup & publish</h4>
                    </div>
                  </li>
                  <li className="process_item process_item_margin_bottom">
                    <div className="process__number">
                      <span>5</span>
                    </div>
                    <div className="process__body margintop_process__body">
                      <h4>It's ready</h4>
                    </div>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default SectionOne;